import { gql } from '@apollo/client'

export const UPDATE_USER_PROFILE = gql`
mutation UpdateMyData($name: String!, $profilePicture: Media, $phoneNumber: String, $targetObjective: String, $objectivesWithPlatform: String, $workflowDescription: String, $jobTitle: String, $emailMarketingOptIn: Boolean) {
  updateMyData(name: $name, profilePicture: $profilePicture, phoneNumber: $phoneNumber, targetObjective: $targetObjective, objectivesWithPlatform: $objectivesWithPlatform, workflowDescription: $workflowDescription, jobTitle: $jobTitle, emailMarketingOptIn: $emailMarketingOptIn) {
    id
    name
    profile_picture
    phone_number
    job_title
    target_objective
    objectives_with_platform
    workflow_description
    email_marketing_opt_in
  }
}
`

// Used by UserLocaleSync; hand-typed there (codegen reads the production schema).
export const GET_MY_LOCALE = gql`
  query GetMyLocale {
    myData {
      id
      locale
    }
  }
`;

export const UPDATE_MY_LOCALE = gql`
  mutation UpdateMyLocale($locale: String!) {
    updateMyData(locale: $locale) {
      id
      locale
    }
  }
`;

export const UPDATE_ONBOARDING = gql`
mutation UpdateOnboarding($onboardingObjective: String!, $jobTitle: String!, $onboardingExperience: String) {
  updateMyData(onboardingObjective: $onboardingObjective, jobTitle: $jobTitle, onboardingExperience: $onboardingExperience) {
    id
    job_title
    onboarding_objective
    onboarding_experience
  }
}
`

export const CHANGE_ONBOARDING_OBJECTIVE = gql`
  mutation ChangeOnboardingObjective($to: String!) {
    changeOnboardingObjective(to: $to) {
      id
      job_title
      onboarding_objective
      onboarding_experience
    }
  }
`;

export const GET_MY_DATA = gql`
query MyData {
  myData {
    id
    name
    email
    provider
    hasPassword
    googleLinked
    role
    is_admin
    job_title
    phone_number
    target_objective
    objectives_with_platform
    workflow_description
    profile_picture
    affiliate
    subscription
    createdAt
    onboarding_objective
    onboarding_experience
    joined_community
    has_challenge_participation
    challenge_participation {
      id
      name
      end_date
    }
    tags {
      id
    }
    cpm_terms_accepted_version
    cpm_terms_accepted_at
    cpm_terms_current_version
    payout_data {
      name
      document
      bank
      agency
      account
      pix_key
    }
    email_marketing_opt_in
  }
}
`

export const SET_PASSWORD = gql`
mutation SetPassword($currentPassword: String, $newPassword: String!) {
  setPassword(currentPassword: $currentPassword, newPassword: $newPassword)
}
`

export const UPDATE_MY_PAYOUT_DATA = gql`
mutation UpdateMyPayoutData($input: UpdateMyPayoutDataInput!) {
  updateMyPayoutData(input: $input) {
    name
    document
    bank
    agency
    account
    pix_key
  }
}
`

export const MARK_COMMUNITY_JOINED = gql`
mutation MarkCommunityJoined {
  markCommunityJoined {
    id
    joined_community
  }
}
`

export const ACCEPT_CPM_TERMS = gql`
mutation AcceptCpmTerms($version: String!) {
  acceptCpmTerms(version: $version) {
    id
    cpm_terms_accepted_version
    cpm_terms_accepted_at
    cpm_terms_current_version
  }
}
`

export const GET_MY_PROJECTS = gql`
query MyProjects($limit: Int, $offset: Int) {
  myProjects(limit: $limit, offset: $offset) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    base_video_url
    compressed_base_video_url
    cut_video_url
    created_by_user
    compressed_cut_video_url
    thumbnail_url
    news_pdf_mirror_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    createdAt
  }
}
`

export const GET_MY_PROJECT = gql`
query MyProject($id: ID!) {
  myProject(id: $id) {
    id
    name
    curation_status
    source_status
    failure_code
    curation_rating
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    base_video_url
    compressed_base_video_url
    cut_video_url
    thumbnail_url
    compressed_cut_video_url
    news_pdf_mirror_url
    speaker_layout
    post_layout
    subtitle_config
    watermark_position
    default_subtitles_enabled
    scene_detection
    scene_detection_url
    video_signals_url
    content_type
    content_type_confidence
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    curated_clips
    clips {
      id
      name
      duration_seconds
      clip_start_time
      clip_end_time
      original_clip_start_time
      original_clip_end_time
      clip_score
      clip_order
      clip_summary
      clip_thumbnail
      curation_rating
      dirty
      clipping_status
      rendering_status
      thumbnail_url
      finished_video_url
      finished_video_thumbnail_url
      data
    }
    transcription
    transcription_url
    original_transcription_url
    brand_kit {
      id
      name
    }
    createdAt
  }
}
`

export const GET_MY_LIBRARIES = gql`
query MyLibraries($limit: Int, $offset: Int, $tagIds: [ID!], $search: String, $channelId: ID, $channelCategory: String) {
  myLibraries(limit: $limit, offset: $offset, tagIds: $tagIds, search: $search, channelId: $channelId, channelCategory: $channelCategory) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    created_by_user
    created_by_user_name
    base_video_url
    compressed_base_video_url
    original_video_url
    cut_video_url
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    tags {
      id
      name
      color
    }
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    source_library_id
    youtube_video_id
    view_count
    upload_date
    createdAt
  }
}
`

export const GET_MY_LIBRARIES_COUNTS = gql`
query MyLibrariesCounts {
  myLibrariesCounts {
    mine
    community
  }
}
`

export const GET_COMMUNITY_LIBRARIES = gql`
query CommunityLibraries($limit: Int, $offset: Int, $search: String, $channelId: ID, $channelCategory: String, $sort: String, $tagId: ID) {
  communityLibraries(limit: $limit, offset: $offset, search: $search, channelId: $channelId, channelCategory: $channelCategory, sort: $sort, tagId: $tagId) {
    id
    name
    curation_status
    format
    language
    processing_mode
    created_by_user
    created_by_user_name
    base_video_url
    compressed_base_video_url
    original_video_url
    cut_video_url
    thumbnail_url
    duration_seconds
    start_time
    end_time
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    source_library_id
    youtube_video_id
    remix_count
    view_count
    upload_date
    createdAt
  }
}
`

export const CHECK_COMMUNITY_LIBRARY_BY_URL = gql`
query CheckCommunityLibraryByUrl($url: String!) {
  checkCommunityLibraryByUrl(url: $url) {
    id
    name
    base_video_url
    duration_seconds
    format
    language
    start_time
    end_time
    active_cpm_campaigns {
      id
    }
    youtube_channels {
      channel_id
    }
  }
}
`

export const GET_COMMUNITY_TAGS = gql`
query CommunityTags($channelId: ID, $channelCategory: String) {
  communityTags(channelId: $channelId, channelCategory: $channelCategory) {
    id
    name
    color
    download_count
  }
}
`

export const GET_COMMUNITY_CHANNELS = gql`
query CommunityChannels($category: String, $search: String, $sort: String) {
  communityChannels(category: $category, search: $search, sort: $sort) {
    id
    channel_id
    name
    url
    thumbnail
    handle
    subscriber_count
    category
    is_autoclipper_partner
    remix_count
  }
}
`

export const CREATE_LIBRARY = gql`
mutation createMyLibrary($input: MyLibraryCreateInput!) {
  createMyLibrary(input: $input) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    prompt
    processing_mode
    remove_silence
    eta_seconds
    created_by_user
    cut_video_url
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    tags {
      id
      name
      color
    }
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    createdAt
  }
}
`

export const DELETE_LIBRARY = gql`
mutation deleteMyLibrary($id: ID!) {
  deleteMyLibrary(id: $id) {
    id
  }
}
`

export const GET_MY_CLIPS = gql`
query MyClips($limit: Int, $offset: Int) {
  myClips(limit: $limit, offset: $offset) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    dirty
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    is_library_clip
    project_id
    library_id
    source_clip_id
    version_number
    curation_rating
    cover_image_url
    can_set_cover
    createdAt
  }
}
`

export const GET_MY_CLIP = gql`
query MyClip($id: ID!) {
  myClip(id: $id) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    clip_start_time
    clip_end_time
    original_clip_start_time
    original_clip_end_time
    clip_summary
    clip_thumbnail
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    curation_rating
    cover_image_url
    can_set_cover
    dirty
    data
    is_library_clip
    project_id
    library_id
    source_clip_id
    version_number
    copy {
      id
      processing_status
      result
      createdAt
      updatedAt
    }
    createdAt
  }
}
`

export const GET_PLANS = gql`
query Plans {
  plans {
    documentId
    name
    slug
    value
    value_yearly
    value_usd
    value_yearly_usd
    processing_seconds
    description_items
    max_clips
    max_library_curations
    max_library_exports
    max_library_video_seconds
    max_brand_kits
    payment_link
    payment_link_yearly
    discount_label
    max_expiry_days
    color
    order
  }
}
`

export const GET_PLAN = gql`
query Plan($id: ID!) {
  plan(id: $id) {
    documentId
    name
    slug
    value
    value_yearly
    value_usd
    value_yearly_usd
    processing_seconds
    description_items
    max_clips
    payment_link
    payment_link_yearly
    discount_label
    color
    order
  }
}
`

export const GET_MY_API_KEYS = gql`
query myApiKeys {
  myAPIKeys {
    id
    name
    key
    createdAt
  }
}
`

export const CREATE_API_KEY = gql`
mutation createMyApiKey($input: MyAPIKeyCreateInput!) {
  createMyAPIKey(input: $input) {
    id
    name
    key
    createdAt
    updatedAt
  }
}
`

export const UPDATE_API_KEY = gql`
mutation updateMyApiKey($id: ID!, $input: MyAPIKeyUpdateInput!) {
  updateMyAPIKey(id: $id, input: $input) {
    id
    name
    key
    createdAt
    updatedAt
  }
}
`

export const DELETE_API_KEY = gql`
mutation deleteMyApiKey($id: ID!) {
  deleteMyAPIKey(id: $id) {
    id
    name
    key
    createdAt
    updatedAt
  }
}
`

export const GET_MY_API_REQUESTS = gql`
query myApiRequests($limit: Int, $offset: Int) {
  myAPIRequests(limit: $limit, offset: $offset) {
    id
    name
    process_status
    base_video_url
    webhook_url
    thumbnail_url
    clips {
      id
      name
      rendered_video_url
    }
    api_key_name
    createdAt
  }
}
`

export const RETRIGGER_API_REQUEST_WEBHOOK = gql`
mutation retriggerMyApiRequestWebhook($id: ID!) {
  retriggerMyAPIRequestWebhook(id: $id) {
    success
  }
}
`

export const CREATE_PROJECT = gql`
mutation createMyProject(
  $input: MyProjectCreateInput!
) {
  createMyProject(
    input: $input
  ) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    prompt
    processing_mode
    remove_silence
    eta_seconds
    base_video_url
    compressed_base_video_url
    cut_video_url
    created_by_user
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    filesize
    start_time
    end_time
    createdAt
  }
}
`

export const DELETE_PROJECT = gql`
mutation deleteMyProject($id: ID!) {
  deleteMyProject(id: $id) {
    id
  }
}
`

export const UPDATE_PROJECT = gql`
mutation updateMyProject($id: ID!, $input: MyProjectUpdateInput!) {
  updateMyProject(id: $id, input: $input) {
    id
    name
    curation_rating
    transcription_url
    speaker_layout
    post_layout
    subtitle_config
    watermark_position
    brand_kit {
      id
      name
    }
  }
}
`

export const CREATE_CLIP = gql`
mutation clipProject(
  $input: ClipProjectInput!
) {
  clipProject(
    input: $input
  ) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    created_by_user
    compressed_video_url
    finished_video_url
    createdAt
  }
}
`

export const ACTIVATE_CLIP = gql`
mutation activateClip(
  $id: ID!
  $input: ActivateClipInput!
) {
  activateClip(
    id: $id
    input: $input
  ) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    created_by_user
    compressed_video_url
    finished_video_url
    createdAt
  }
}
`

export const CREATE_CLIP_TITLES = gql`
mutation createClipTitles(
  $id: ID!
) {
  createCopies(
    id: $id
  ) {
    id
    copy {
      id
      processing_status
      result
      createdAt
      updatedAt
    }
  }
}
`

export const ACCEPT_INVITATION = gql`
mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    id
    name
    email
    subscription
    createdAt
  }
}
`

export const LEAVE_TEAM = gql`
mutation LeaveTeam {
  leaveTeam {
    id
    name
    email
    subscription
    createdAt
  }
}
`

export const REMOVE_TEAM_ACCESS = gql`
mutation RemoveTeamAccess($email: String!) {
  removeTeamAccess(email: $email) {
    id
    name
    email
    job_title
    profile_picture
    affiliate
    subscription
    createdAt
  }
}
`

export const UPDATE_TEAM_ROLE = gql`
mutation UpdateTeamRole($email: String!, $role: String!) {
  updateTeamRole(email: $email, role: $role) {
    id
    name
    email
    subscription
    createdAt
  }
}
`

export const REFRESH_INVITATION_TOKEN = gql`
mutation RefreshInvitationToken {
  refreshInvitationToken {
    id
    name
    email
    subscription
    createdAt
  }
}
`

export const RENDER_CLIP = gql`
mutation renderClip(
  $id: ID!
  $input: JSON!
) {
  renderClip(
    id: $id
    input: $input
  ) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    createdAt
  }
}
`

export const RENDER_LIBRARY_CLIP = gql`
mutation renderLibraryClip(
  $id: ID!
  $input: JSON!
) {
  renderLibraryClip(
    id: $id
    input: $input
  ) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    source_clip_id
    version_number
    createdAt
  }
}
`

export const PREPARE_CLIP = gql`
mutation prepareClip(
  $id: ID!
) {
  prepareClip(
    id: $id
  ) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    createdAt
  }
}
`

export const SET_CANCELLATION_REASON = gql`
mutation setCancellationReason(
  $reason: String!
  $feedback: String!
) {
  setCancellationReason(reason: $reason, feedback: $feedback) {
    success
  }
}
`

export const GET_MY_FONTS = gql`
query myFonts {
  myFonts {
    id
    name
    family
    file_url
    preview_black_url
    preview_white_url
    createdAt
    updatedAt
  }
}
`

export const GET_MY_BRAND_KITS = gql`
query myBrandKits {
  myBrandKits {
    id
    name
    is_default
    is_public
    preview_video_url
    preview_poster_url
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
`

export const GET_MY_BRAND_KIT = gql`
query myBrandKit($id: ID!) {
  myBrandKit(id: $id) {
    id
    name
    is_default
    is_public
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
`

export const CREATE_MY_BRAND_KIT = gql`
mutation createMyBrandKit($input: MyBrandKitCreateInput!) {
  createMyBrandKit(input: $input) {
    id
    name
    is_default
    is_public
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
`

export const UPDATE_MY_BRAND_KIT = gql`
mutation updateMyBrandKit($id: ID!, $input: MyBrandKitUpdateInput!) {
  updateMyBrandKit(id: $id, input: $input) {
    id
    name
    is_default
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
`

export const DELETE_MY_BRAND_KIT = gql`
mutation DeleteMyBrandKit($id: ID!) {
  deleteMyBrandKit(id: $id) {
    id
    name
    createdAt
    updatedAt
  }
}
`

export const ADMIN_CREATE_BRAND_KIT = gql`
mutation adminCreateBrandKit($input: MyBrandKitCreateInput!) {
  adminCreateBrandKit(input: $input) {
    id
    name
    is_default
    is_public
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
`

export const RATE_CLIP = gql`
mutation rateClip($id: ID!, $rating: String!) {
  rateClip(id: $id, rating: $rating) {
    id
    curation_rating
  }
}
`

export const UPDATE_CLIP_DATA = gql`
mutation updateClipData($id: ID!, $data: JSON!) {
  updateClipData(id: $id, data: $data) {
    id
    data
    dirty
  }
}
`

export const ADD_USER_TAG = gql`
mutation addUserTag($name: String!) {
  addUserTag(
    name: $name
  ) {
    id
  }
}
`

export const VALIDATE_COUPON = gql`
query validateCoupon($code: String!, $planId: ID!, $recurrency: String!) {
  validateCoupon(code: $code, planId: $planId, recurrency: $recurrency) {
    error
    valid
    coupon {
      id
      code
      cycles
      discount
      expiry_date
    }
  }
}
`

export const GET_CLIPS_BY_PROJECT_ID = gql`
query MyClipsByProjectId($limit: Int, $offset: Int, $project_id: ID!, $sort: String) {
  myClips(limit: $limit, offset: $offset, project_id: $project_id, sort: $sort) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    dirty
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    curation_rating
    data
    source_clip_id
    version_number
    createdAt
  }
}
`

export const RENDER_PROJECT_CLIP_V2 = gql`
mutation renderProjectClipV2(
  $id: ID!
  $input: JSON!
) {
  renderProjectClipV2(
    id: $id
    input: $input
  ) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    source_clip_id
    version_number
    createdAt
  }
}
`

export const GET_MY_LIBRARY = gql`
query MyLibrary($id: ID!) {
  myLibrary(id: $id) {
    id
    name
    curation_status
    source_status
    failure_code
    curation_rating
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    created_by_user
    created_by_user_name
    base_video_url
    compressed_base_video_url
    cut_video_url
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    scene_detection
    scene_detection_url
    curated_clips
    speaker_layout
    post_layout
    subtitle_config
    watermark_position
    default_subtitles_enabled
    transcription
    transcription_url
    original_transcription_url
    clips {
      id
      name
      duration_seconds
      clip_start_time
      clip_end_time
      original_clip_start_time
      original_clip_end_time
      clip_score
      clip_order
      clip_summary
      clip_thumbnail
      curation_rating
      dirty
      clipping_status
      rendering_status
      thumbnail_url
      finished_video_url
      finished_video_thumbnail_url
      data
    }
    brand_kit {
      id
      name
    }
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    createdAt
  }
}
`

export const GET_CLIPS_BY_LIBRARY_ID = gql`
query MyClipsByLibraryId($limit: Int, $offset: Int, $library_id: ID!, $sort: String) {
  myClips(limit: $limit, offset: $offset, library_id: $library_id, sort: $sort) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    clip_start_time
    clip_end_time
    dirty
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    curation_rating
    data
    source_clip_id
    version_number
    createdAt
  }
}
`

export const DELETE_MY_CLIP = gql`
mutation DeleteMyClip($id: ID!) {
  deleteMyClip(id: $id) {
    id
  }
}
`

// Admin queries
export const GET_ADMIN_USER = gql`
query AdminUser($id: ID!) {
  adminUser(id: $id) {
    id
    name
    email
    phone_number
    job_title
    is_admin
    provider
    confirmed
    blocked
    onboarding_objective
    profile_picture
    account_reliabilities {
      platform
      status
      score
      engagement_rate
      lifetime_views
      tracked_content
      username
    }
    subscription {
      id
      current_month_processing_seconds
      current_month_clips
      current_month_library_video_seconds
      current_month_library_exports
      current_month_library_curations
      extra_clips
      extra_seconds
      payment_provider
      payment_recurrency
      next_payment_at
      cancellation_at
      payment_count
      total_payment_value
      original_price
      discounted_price
      discount_amount
      active_coupon {
        id
        code
        type
        month_discount
        year_discount
        month_cycles
        year_cycles
      }
      plan {
        id
        name
        slug
        value
        processing_seconds
        max_clips
        max_users
        max_library_video_seconds
        max_library_exports
        max_library_curations
      }
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
}
`

export const GET_ADMIN_USERS = gql`
query AdminUsers($page: Int, $pageSize: Int, $search: String, $name: String, $email: String, $phone_number: String, $plan_slug: String, $is_partner: Boolean) {
  adminUsers(page: $page, pageSize: $pageSize, search: $search, name: $name, email: $email, phone_number: $phone_number, plan_slug: $plan_slug, is_partner: $is_partner) {
    data {
      id
      name
      email
      phone_number
      job_title
      is_admin
      blocked
      confirmed
      provider
      onboarding_objective
      utm_source
      utm_medium
      utm_campaign
      utm_term
      utm_content
      affiliate_rate_payment
      affiliate_rate_course
      affiliate_rate_cpm
      affiliate_rate_note
      cpm_leaderboard_excluded
      cpm_leaderboard_excluded_reason
      account_reliabilities {
        platform
        status
        score
        engagement_rate
        lifetime_views
        tracked_content
        username
      }
      subscription {
        id
        current_month_processing_seconds
        current_month_clips
        current_month_library_video_seconds
        current_month_library_exports
        current_month_library_curations
        extra_clips
        is_partner
        partner_expires_at
        partner_note
        ai_assistant_granted
        facebook_connections_granted
        extra_seconds
        payment_count
        total_payment_value
        plan {
          id
          name
          slug
          processing_seconds
          max_clips
          max_library_video_seconds
          max_library_exports
          max_library_curations
        }
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_BOT_CHAT_CONVERSATIONS = gql`
query AdminBotChatConversations($page: Int, $pageSize: Int, $search: String, $channel: String, $linked: Boolean, $hasError: Boolean, $userId: ID, $sortBy: String, $sortOrder: String) {
  adminBotChatConversations(page: $page, pageSize: $pageSize, search: $search, channel: $channel, linked: $linked, hasError: $hasError, userId: $userId, sortBy: $sortBy, sortOrder: $sortOrder) {
    data {
      id
      channel
      channel_user_id
      first_seen_at
      last_seen_at
      message_count
      error_count
      memory_summary
      memory_updated_at
      user {
        id
        name
        email
        phone_number
      }
    }
    total
    page
    pageSize
    pageCount
  }
}
`

export const GET_ADMIN_BOT_CHAT_CONVERSATION = gql`
query AdminBotChatConversation($id: ID!) {
  adminBotChatConversation(id: $id) {
    id
    channel
    channel_user_id
    first_seen_at
    last_seen_at
    message_count
    error_count
    memory_summary
    memory_updated_at
    user {
      id
      name
      email
      phone_number
    }
  }
}
`

export const GET_ADMIN_BOT_CHAT_MESSAGES = gql`
query AdminBotChatMessages($conversationId: ID!, $page: Int, $pageSize: Int, $order: String) {
  adminBotChatMessages(conversationId: $conversationId, page: $page, pageSize: $pageSize, order: $order) {
    data {
      id
      direction
      text
      intent_kind
      intent_source
      current_flow
      error
      llm_model
      createdAt
    }
    total
    page
    pageSize
    pageCount
  }
}
`

export const GET_ADMIN_PROJECTS = gql`
query AdminProjects($page: Int, $pageSize: Int, $search: String, $name: String, $user_id: ID, $curation_status: String, $language: String, $sortBy: String, $sortOrder: String) {
  adminProjects(page: $page, pageSize: $pageSize, search: $search, name: $name, user_id: $user_id, curation_status: $curation_status, language: $language, sortBy: $sortBy, sortOrder: $sortOrder) {
    data {
      id
      name
      curation_status
      language
      duration_seconds
      format
      deleted
      created_by_user {
        id
        name
        email
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_CLIPS = gql`
query AdminClips($page: Int, $pageSize: Int, $search: String, $name: String, $user_id: ID, $project_id: ID, $clipping_status: String, $rendering_status: String, $sortBy: String, $sortOrder: String) {
  adminClips(page: $page, pageSize: $pageSize, search: $search, name: $name, user_id: $user_id, project_id: $project_id, clipping_status: $clipping_status, rendering_status: $rendering_status, sortBy: $sortBy, sortOrder: $sortOrder) {
    data {
      id
      name
      clipping_status
      preparing_status
      rendering_status
      duration_seconds
      deleted
      project {
        id
        name
      }
      clipped_video_url
      finished_video_url
      created_by_user {
        id
        name
        email
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_YOUTUBE_DOWNLOADS = gql`
query AdminYouTubeDownloads($page: Int, $pageSize: Int, $search: String, $video_id: String, $download_status: String, $provider: String, $language: String, $sortBy: String, $sortOrder: String) {
  adminYouTubeDownloads(page: $page, pageSize: $pageSize, search: $search, video_id: $video_id, download_status: $download_status, provider: $provider, language: $language, sortBy: $sortBy, sortOrder: $sortOrder) {
    data {
      id
      video_id
      download_status
      provider
      language
      hash
      priority
      linked_projects_count
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_COUPONS = gql`
query AdminCoupons($page: Int, $pageSize: Int, $search: String, $code: String, $type: String, $active: Boolean) {
  adminCoupons(page: $page, pageSize: $pageSize, search: $search, code: $code, type: $type, active: $active) {
    data {
      id
      documentId
      code
      type
      quantity
      month_cycles
      month_discount
      year_cycles
      year_discount
      expiry_date
      createdAt
      updatedAt
      assigned_user {
        id
        name
        email
      }
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_COUPON = gql`
query AdminCoupon($id: ID!) {
  adminCoupon(id: $id) {
    id
    documentId
    code
    type
    quantity
    month_cycles
    month_discount
    year_cycles
    year_discount
    expiry_date
    createdAt
    updatedAt
    assigned_user {
      id
      name
      email
    }
  }
}
`

export const CREATE_ADMIN_COUPON = gql`
mutation AdminCreateCoupon($input: AdminCouponCreateInput!) {
  adminCreateCoupon(input: $input) {
    id
    code
    type
    quantity
    month_cycles
    month_discount
    year_cycles
    year_discount
    expiry_date
    assigned_user {
      id
      name
      email
    }
  }
}
`

export const UPDATE_ADMIN_COUPON = gql`
mutation AdminUpdateCoupon($id: ID!, $input: AdminCouponUpdateInput!) {
  adminUpdateCoupon(id: $id, input: $input) {
    id
    code
    type
    quantity
    month_cycles
    month_discount
    year_cycles
    year_discount
    expiry_date
    assigned_user {
      id
      name
      email
    }
  }
}
`

export const DELETE_ADMIN_COUPON = gql`
mutation AdminDeleteCoupon($id: ID!) {
  adminDeleteCoupon(id: $id) {
    id
  }
}
`

export const GET_COMMUNITY_LIVE_SESSIONS = gql`
query CommunityLiveSessions {
  communityLiveSessions {
    id
    platform
    live_url
    started_at
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    library {
      id
      name
      duration_seconds
      format
      language
      start_time
      end_time
      base_video_url
      thumbnail_url
    }
  }
}
`

export const GET_ADMIN_LIVE_WATCHES = gql`
query AdminLiveWatches($page: Int, $pageSize: Int, $search: String, $platform: LiveWatchPlatform, $enabled: Boolean) {
  adminLiveWatches(page: $page, pageSize: $pageSize, search: $search, platform: $platform, enabled: $enabled) {
    data {
      id
      kind
      platform
      platform_channel_id
      platform_login
      source_url
      enabled
      window_minutes
      retention_days
      overlap_seconds
      youtube_channel {
        id
        channel_id
        name
        thumbnail
        handle
      }
      current_session {
        id
        status
        platform_live_id
        live_url
        started_at
        ended_at
        last_error
        ingest_status
        heartbeat_at
        r2_prefix
        retention_expires_at
      }
      createdAt
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_LIVE_WATCH = gql`
query AdminLiveWatch($id: ID!) {
  adminLiveWatch(id: $id) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
`

export const GET_ADMIN_LIVE_SESSIONS = gql`
query AdminLiveSessions($watchId: ID!, $page: Int, $pageSize: Int) {
  adminLiveSessions(watchId: $watchId, page: $page, pageSize: $pageSize) {
    data {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const CREATE_ADMIN_LIVE_WATCH = gql`
mutation AdminCreateLiveWatch($input: AdminCreateLiveWatchInput!) {
  adminCreateLiveWatch(input: $input) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
`

export const UPDATE_ADMIN_LIVE_WATCH = gql`
mutation AdminUpdateLiveWatch($id: ID!, $input: AdminCreateLiveWatchInput!) {
  adminUpdateLiveWatch(id: $id, input: $input) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
`

export const SET_ADMIN_LIVE_WATCH_ENABLED = gql`
mutation AdminSetLiveWatchEnabled($id: ID!, $enabled: Boolean!) {
  adminSetLiveWatchEnabled(id: $id, enabled: $enabled) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
`

export const STOP_ADMIN_LIVE_SESSION = gql`
mutation AdminStopLiveSession($id: ID!) {
  adminStopLiveSession(id: $id) {
    id
    status
    platform_live_id
    live_url
    started_at
    ended_at
    last_error
    ingest_status
    heartbeat_at
    r2_prefix
    retention_expires_at
  }
}
`

export const GET_ADMIN_LIVE_WINDOWS = gql`
query AdminLiveWindows($sessionId: ID!, $page: Int, $pageSize: Int) {
  adminLiveWindows(sessionId: $sessionId, page: $page, pageSize: $pageSize) {
    data {
      id
      window_start
      window_end
      status
      library_document_id
      attempt_count
      last_error
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_YOUTUBE_CHANNELS = gql`
query AdminYoutubeChannels($page: Int, $pageSize: Int, $search: String, $partnerOnly: Boolean) {
  adminYoutubeChannels(page: $page, pageSize: $pageSize, search: $search, partnerOnly: $partnerOnly) {
    data {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
      is_autoclipper_partner
    }
    total
    page
    pageSize
    pageCount
  }
}
`

export const UPDATE_ADMIN_YOUTUBE_CHANNEL = gql`
mutation AdminUpdateYoutubeChannel($id: ID!, $is_autoclipper_partner: Boolean!) {
  adminUpdateYoutubeChannel(id: $id, is_autoclipper_partner: $is_autoclipper_partner) {
    id
    channel_id
    name
    is_autoclipper_partner
  }
}
`

export const ADMIN_IMPORT_DRIVE_TO_CHANNEL = gql`
  mutation AdminImportDriveToChannel($channelId: ID!, $urls: [String!]!) {
    adminImportDriveToChannel(channelId: $channelId, urls: $urls) {
      input
      status
      fileId
      fileName
      downloadId
      error
    }
  }
`

export const GET_ADMIN_PLANS = gql`
query AdminPlans {
  adminPlans {
    id
    name
    slug
    processing_seconds
    max_clips
    max_library_video_seconds
    max_library_exports
    max_library_curations
    value
    order
  }
}
`

export const APPLY_RENEWAL_COUPON = gql`
  mutation ApplyRenewalCoupon($code: String!) {
    applyRenewalCoupon(code: $code) {
      code
      type
      discount
      cycles
      renewal_price_cents
      pix_order_regenerated
    }
  }
`;

export const CREATE_PIX_RENEWAL_ORDER = gql`
mutation CreatePixRenewalOrder($resetNow: Boolean) {
  createPixRenewalOrder(resetNow: $resetNow) {
    id
    amount
    status
    pix_code
    pix_qr_code_url
    expires_at
  }
}
`

export const START_RENEWED_CYCLE_NOW = gql`
mutation StartRenewedCycleNow {
  startRenewedCycleNow
}
`

export const GET_ADMIN_STATS = gql`
query AdminStats($startDate: String, $endDate: String) {
  adminStats(startDate: $startDate, endDate: $endDate) {
    planCustomerCounts {
      plan_id
      plan_name
      plan_slug
      customer_count
    }
    users {
      total
      admins
      blocked
      confirmed
      timeSeries {
        date
        total
        success
        failure
      }
      utmTimeSeries {
        date
        utm_source
        count
      }
    }
    projects {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
    libraryProjects {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
    clips {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
    youtubeDownloads {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
  }
}
`

export const GET_ADMIN_FUNNEL_STATS = gql`
query AdminFunnelStats {
  adminFunnelStats {
    own_brand {
      label
      count
    }
    other_channels {
      label
      count
    }
  }
}
`

export const GET_ADMIN_RESULTS_DASHBOARD = gql`
query AdminResultsDashboard($startDate: String, $endDate: String) {
  adminResultsDashboard(startDate: $startDate, endDate: $endDate) {
    dateRange {
      startDate
      endDate
      days
      capped
    }
    conversion {
      totalFree
      totalPaid
      rate
    }
    funnelCreator {
      label
      count
      pct
    }
    funnelClipper {
      label
      count
      pct
    }
    sourcesCreator {
      key
      label
      count
      pct
    }
    sourcesClipper {
      key
      label
      count
      pct
    }
    retentionCreator {
      period
      pct
      retained
      cohort
    }
    retentionClipper {
      period
      pct
      retained
      cohort
    }
    campaigns {
      enrolled
      submitted
      approved
      earningsCents
      clipperToPaidPct
      subscriberToCampaignPct
    }
    nwc {
      total
      paidPct
      campaignPct
      retentionD1
      retentionD7
      retentionD30
      organicRetentionD1
      organicRetentionD7
      organicRetentionD30
    }
    activity {
      date
      users
      clips
    }
  }
}
`

export const ADMIN_RESTORE_EXPIRED_ITEMS = gql`
mutation AdminRestoreExpiredItems($userId: ID!) {
  adminRestoreExpiredItems(userId: $userId) {
    restoredProjects
    restoredClips
  }
}
`

export const ADMIN_RESTORE_EXPIRED_PROJECT = gql`
mutation AdminRestoreExpiredProject($id: ID!) {
  adminRestoreExpiredProject(id: $id)
}
`

export const ADMIN_RESTORE_EXPIRED_CLIP = gql`
mutation AdminRestoreExpiredClip($id: ID!) {
  adminRestoreExpiredClip(id: $id)
}
`

export const ADMIN_RETRY_FAILED_PROJECT = gql`
mutation AdminRetryFailedProject($id: ID!) {
  adminRetryFailedProject(id: $id)
}
`

export const ADMIN_RETRY_FAILED_CLIP = gql`
mutation AdminRetryFailedClip($id: ID!) {
  adminRetryFailedClip(id: $id)
}
`

export const ADMIN_FETCH_CHANNEL_VIDEOS = gql`
query AdminFetchChannelVideos($channelUrl: String!) {
  adminFetchChannelVideos(channelUrl: $channelUrl) {
    id
    title
    url
    thumbnail
    duration
    publishedAt
    viewCount
    channel
  }
}
`

export const ADMIN_LIBRARIES = gql`
query AdminLibraries($page: Int, $pageSize: Int, $search: String, $curation_status: String, $sortBy: String, $sortOrder: String) {
  adminLibraries(page: $page, pageSize: $pageSize, search: $search, curation_status: $curation_status, sortBy: $sortBy, sortOrder: $sortOrder) {
    data {
      id
      name
      curation_status
      language
      format
      prompt
      base_video_url
      thumbnail_url
      duration_seconds
      deleted
      created_by_user {
        id
        email
        name
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    pageCount
  }
}
`

export const ADMIN_ADD_TO_LIBRARY = gql`
mutation AdminAddToLibrary($input: AdminAddToLibraryInput!) {
  adminAddToLibrary(input: $input) {
    id
    name
    curation_status
    language
    format
    prompt
    base_video_url
    thumbnail_url
    duration_seconds
    createdAt
    updatedAt
  }
}
`

export const ADMIN_DELETE_LIBRARY = gql`
mutation AdminDeleteLibrary($id: ID!) {
  adminDeleteLibrary(id: $id)
}
`

export const ADMIN_RETRY_FAILED_LIBRARY = gql`
mutation AdminRetryFailedLibrary($id: ID!) {
  adminRetryFailedLibrary(id: $id)
}
`

export const ADMIN_RESTORE_EXPIRED_LIBRARY = gql`
mutation AdminRestoreExpiredLibrary($id: ID!) {
  adminRestoreExpiredLibrary(id: $id)
}
`

export const ADMIN_IMPERSONATE_USER = gql`
mutation AdminImpersonateUser($userId: ID!) {
  adminImpersonateUser(userId: $userId) {
    jwt
  }
}
`

export const ADMIN_UPDATE_USER_SUBSCRIPTION = gql`
mutation AdminUpdateUserSubscription($userId: ID!, $input: AdminUpdateUserSubscriptionInput!) {
  adminUpdateUserSubscription(userId: $userId, input: $input) {
    id
    name
    email
    onboarding_objective
    subscription {
      id
      current_month_processing_seconds
      current_month_clips
      current_month_library_video_seconds
      current_month_library_exports
      current_month_library_curations
      extra_clips
      is_partner
      partner_expires_at
      partner_note
      extra_seconds
      plan {
        id
        name
        slug
        max_library_curations
        max_library_exports
        max_library_video_seconds
      }
    }
  }
}
`

export const ADMIN_SET_AFFILIATE_RATES = gql`
  mutation AdminSetAffiliateRates($userId: ID!, $input: AdminAffiliateRatesInput!) {
    adminSetAffiliateRates(userId: $userId, input: $input) {
      id
      affiliate_rate_payment
      affiliate_rate_course
      affiliate_rate_cpm
      affiliate_rate_note
    }
  }
`;

export const ADMIN_SET_CPM_LEADERBOARD_EXCLUSION = gql`
  mutation AdminSetCpmLeaderboardExclusion($userId: ID!, $excluded: Boolean!, $reason: String) {
    adminSetCpmLeaderboardExclusion(userId: $userId, excluded: $excluded, reason: $reason) {
      id
      cpm_leaderboard_excluded
      cpm_leaderboard_excluded_reason
    }
  }
`;

export const ACTIVE_CHALLENGE = gql`
  query ActiveChallenge {
    activeChallenge {
      id
      name
      description
      start_date
      end_date
      prize_pool
      warning_message
      rules_allowed
      rules_forbidden
      rules_attention
      is_accepting_participants
      required_hashtags
      caption_examples
      prize_data
      my_participation {
        id
        user_id
        user_name
        user_email
        user_profile_picture
        disqualified
        disqualification_reason
        challenge_clips {
          id
          platform
          url
          total_views
          admin_approval
          approval_reason
          validated_hashtags
          challenge_clip_views {
            id
            date
            platform
            views
            likes
            comments
            shares
            saves
            favorites
          }
          createdAt
        }
        total_views
        createdAt
      }
      ranking {
        participation_id
        user_id
        user_name
        user_profile_picture
        total_views
        clip_count
      }
    }
  }
`

export const GET_CHALLENGE = gql`
  query GetChallenge($id: ID!) {
    challenge(id: $id) {
      id
      name
      description
      start_date
      end_date
      prize_pool
      warning_message
      rules_allowed
      rules_forbidden
      rules_attention
      is_accepting_participants
      required_hashtags
      caption_examples
      prize_data
      my_participation {
        id
        user_id
        user_name
        user_email
        user_profile_picture
        disqualified
        disqualification_reason
        challenge_clips {
          id
          platform
          url
          total_views
          admin_approval
          approval_reason
          validated_hashtags
          challenge_clip_views {
            id
            date
            platform
            views
            likes
            comments
            shares
            saves
            favorites
          }
          createdAt
        }
        total_views
        createdAt
      }
      ranking {
        participation_id
        user_id
        user_name
        user_profile_picture
        total_views
        clip_count
      }
      rankings {
        id
        name
        timezone
        is_consolidated
        admin_validated
        consolidated_at
        ranking_data
        partial_ranking {
          participation_id
          user_id
          user_name
          user_profile_picture
          total_views
          clip_count
        }
        time_until_start_seconds
        time_until_end_seconds
      }
    }
  }
`

export const JOIN_CHALLENGE = gql`
  mutation JoinChallenge($challengeId: ID!) {
    joinChallenge(challengeId: $challengeId) {
      id
      user_id
      challenge_clips {
        id
        platform
        url
        total_views
        createdAt
      }
      total_views
      createdAt
    }
  }
`

export const SUBMIT_CHALLENGE_CLIP = gql`
  mutation SubmitChallengeClip($input: SubmitChallengeClipInput!) {
    submitChallengeClip(input: $input) {
      id
      platform
      url
      total_views
      createdAt
    }
  }
`

export const VALIDATE_CHALLENGE_CLIP_HASHTAGS = gql`
  mutation ValidateChallengeClipHashtags($input: ValidateChallengeClipInput!) {
    validateChallengeClipHashtags(input: $input) {
      hashtags_valid
      missing_hashtags
    }
  }
`

export const GET_ADMIN_CHALLENGES = gql`
query AdminChallenges($page: Int, $pageSize: Int, $search: String) {
  adminChallenges(page: $page, pageSize: $pageSize, search: $search) {
    data {
      id
      name
      description
      start_date
      end_date
      prize_pool
      warning_message
      rules_allowed
      rules_forbidden
      rules_attention
      is_accepting_participants
      required_hashtags
      caption_examples
      prize_data
      rankings {
        id
        name
        timezone
        is_consolidated
        consolidated_at
        ranking_data
      }
      participants {
        id
        user_id
        user_name
        user_email
        total_views
        clip_count
        challenge_clips {
          id
          platform
          url
          total_views
          admin_approval
          approval_reason
          validated_hashtags
          createdAt
        }
        createdAt
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const GET_ADMIN_CHALLENGE = gql`
query AdminChallenge($id: ID!) {
  adminChallenge(id: $id) {
    id
    name
    description
    start_date
    end_date
    prize_pool
    warning_message
    rules_allowed
    rules_forbidden
    rules_attention
    is_accepting_participants
    required_hashtags
    caption_examples
    prize_data
    rankings {
      id
      name
      timezone
      is_consolidated
      admin_validated
      consolidated_at
      ranking_data
      partial_ranking {
        participation_id
        user_id
        user_name
        user_profile_picture
        total_views
        clip_count
      }
      start_date
      end_date
      start_snapshotted_at
      end_snapshotted_at
      time_until_start_seconds
      time_until_end_seconds
    }
    participants {
      id
      user_id
      user_name
      user_email
      total_views
      clip_count
      subscription {
        id
        current_month_processing_seconds
        current_month_clips
        current_month_library_video_seconds
        current_month_library_exports
        plan {
          id
          name
          processing_seconds
          max_clips
          max_library_video_seconds
          max_library_exports
        }
        createdAt
        updatedAt
      }
      challenge_clips {
        id
        platform
        url
        total_views
        admin_approval
        approval_reason
        validated_hashtags
        createdAt
      }
      disqualified
      disqualification_reason
      createdAt
    }
    createdAt
    updatedAt
  }
}
`

export const ADMIN_CREATE_CHALLENGE = gql`
mutation AdminCreateChallenge($input: AdminChallengeCreateInput!) {
  adminCreateChallenge(input: $input) {
    id
    name
    start_date
    end_date
    prize_pool
    createdAt
  }
}
`

export const ADMIN_UPDATE_CHALLENGE = gql`
mutation AdminUpdateChallenge($id: ID!, $input: AdminChallengeUpdateInput!) {
  adminUpdateChallenge(id: $id, input: $input) {
    id
    name
    start_date
    end_date
    prize_pool
    createdAt
  }
}
`

export const ADMIN_DELETE_CHALLENGE = gql`
mutation AdminDeleteChallenge($id: ID!) {
  adminDeleteChallenge(id: $id)
}
`

export const ADMIN_ADD_CHALLENGE_PARTICIPANT = gql`
mutation AdminAddChallengeParticipant($challengeId: ID!, $email: String!, $phone: String, $name: String) {
  adminAddChallengeParticipant(challengeId: $challengeId, email: $email, phone: $phone, name: $name) {
    id
    user_id
    user_name
    user_email
    total_views
    clip_count
    challenge_clips {
      id
      platform
      url
      total_views
      admin_approval
      approval_reason
      createdAt
    }
    was_created
    createdAt
  }
}
`

export const ADMIN_REMOVE_CHALLENGE_PARTICIPANT = gql`
mutation AdminRemoveChallengeParticipant($challengeId: ID!, $participantId: ID!) {
  adminRemoveChallengeParticipant(challengeId: $challengeId, participantId: $participantId)
}
`

export const ADMIN_DISQUALIFY_PARTICIPANT = gql`
mutation AdminDisqualifyParticipant($participantId: ID!, $disqualified: Boolean!, $reason: String) {
  adminDisqualifyParticipant(participantId: $participantId, disqualified: $disqualified, reason: $reason)
}
`

export const ADMIN_RESET_CHALLENGE_PARTICIPANT_USAGE = gql`
mutation AdminResetChallengeParticipantUsage($challengeId: ID!, $participantId: ID!) {
  adminResetChallengeParticipantUsage(challengeId: $challengeId, participantId: $participantId)
}
`

export const ADMIN_RESET_ALL_CHALLENGE_PARTICIPANTS_USAGE = gql`
mutation AdminResetAllChallengeParticipantsUsage($challengeId: ID!) {
  adminResetAllChallengeParticipantsUsage(challengeId: $challengeId)
}
`

export const ADMIN_CREATE_CHALLENGE_RANKING = gql`
mutation AdminCreateChallengeRanking($challengeId: ID!, $input: AdminChallengeRankingCreateInput!) {
  adminCreateChallengeRanking(challengeId: $challengeId, input: $input) {
    id
    name
    timezone
    is_consolidated
    admin_validated
    consolidated_at
    ranking_data
  }
}
`

export const ADMIN_UPDATE_CHALLENGE_RANKING = gql`
mutation AdminUpdateChallengeRanking($id: ID!, $input: AdminChallengeRankingUpdateInput!) {
  adminUpdateChallengeRanking(id: $id, input: $input) {
    id
    name
    timezone
    is_consolidated
    admin_validated
    consolidated_at
    ranking_data
  }
}
`

export const ADMIN_DELETE_CHALLENGE_RANKING = gql`
mutation AdminDeleteChallengeRanking($id: ID!) {
  adminDeleteChallengeRanking(id: $id)
}
`

export const ADMIN_VALIDATE_RANKING = gql`
mutation AdminValidateRanking($id: ID!, $validated: Boolean!) {
  adminValidateRanking(id: $id, validated: $validated) {
    id
    name
    timezone
    is_consolidated
    admin_validated
    consolidated_at
    ranking_data
    start_date
    end_date
  }
}
`

export const GET_ADMIN_CHALLENGE_CLIPS = gql`
query AdminChallengeClips($challengeId: ID!, $page: Int, $pageSize: Int, $search: String, $approval: String, $validated_hashtags: String) {
  adminChallengeClips(challengeId: $challengeId, page: $page, pageSize: $pageSize, search: $search, approval: $approval, validated_hashtags: $validated_hashtags) {
    data {
      id
      platform
      url
      total_views
      admin_approval
      approval_reason
      validated_hashtags
      participant_id
      participant_user_name
      participant_user_email
      createdAt
    }
    page
    pageSize
    pageCount
    total
  }
}
`

export const ADMIN_SET_CHALLENGE_CLIP_APPROVAL = gql`
mutation AdminSetChallengeClipApproval($id: ID!, $approval: String!, $reason: String) {
  adminSetChallengeClipApproval(id: $id, approval: $approval, reason: $reason)
}
`

export const ADMIN_SET_CHALLENGE_CLIP_HASHTAG_VALIDATION = gql`
mutation AdminSetChallengeClipHashtagValidation($id: ID!, $validated_hashtags: String!) {
  adminSetChallengeClipHashtagValidation(id: $id, validated_hashtags: $validated_hashtags)
}
`

export const GET_ADMIN_RANKING_SNAPSHOTS = gql`
query AdminRankingSnapshots($rankingId: ID!) {
  adminRankingSnapshots(rankingId: $rankingId) {
    ranking_id
    ranking_name
    start_views {
      snapshot_view_id
      clip_id
      clip_url
      clip_platform
      participant_name
      participant_id
      views
    }
    end_views {
      snapshot_view_id
      clip_id
      clip_url
      clip_platform
      participant_name
      participant_id
      views
    }
  }
}
`

export const GET_ADMIN_PARTIAL_RANKING_BY_DATE_RANGE = gql`
query AdminPartialRankingByDateRange($challengeId: ID!, $startDate: String, $endDate: String, $timezone: String) {
  adminPartialRankingByDateRange(challengeId: $challengeId, startDate: $startDate, endDate: $endDate, timezone: $timezone) {
    entries {
      participation_id
      user_name
      clip_count
      total_views
    }
    clips_without_views {
      clip_id
      clip_url
      participant_name
      missing
    }
    start_date_used
    end_date_used
  }
}
`

export const GET_ADMIN_CHALLENGE_VIEWS_TIME_SERIES = gql`
query AdminChallengeViewsTimeSeries($challengeId: ID!, $days: Int) {
  adminChallengeViewsTimeSeries(challengeId: $challengeId, days: $days) {
    date
    total_views
    clip_count
  }
}
`

export const ADMIN_FORCE_START_SNAPSHOT = gql`
mutation AdminForceStartSnapshot($rankingId: ID!) {
  adminForceStartSnapshot(rankingId: $rankingId) {
    id
    name
    start_snapshotted_at
    end_snapshotted_at
  }
}
`

export const ADMIN_FORCE_CONSOLIDATION = gql`
mutation AdminForceConsolidation($rankingId: ID!) {
  adminForceConsolidation(rankingId: $rankingId) {
    id
    name
    is_consolidated
    consolidated_at
    ranking_data
    start_snapshotted_at
    end_snapshotted_at
  }
}
`

export const ADMIN_UPDATE_SNAPSHOT_VIEW = gql`
mutation AdminUpdateSnapshotView($id: ID!, $views: String!) {
  adminUpdateSnapshotView(id: $id, views: $views)
}
`

export const ADMIN_CREATE_MANUAL_CLIP_VIEW = gql`
mutation AdminCreateManualClipView($clipId: ID!, $views: String!, $date: String) {
  adminCreateManualClipView(clipId: $clipId, views: $views, date: $date)
}
`

export const ADMIN_FORCE_UPDATE_ALL_CHALLENGE_CLIP_VIEWS = gql`
mutation AdminForceUpdateAllChallengeClipViews($challengeId: ID!) {
  adminForceUpdateAllChallengeClipViews(challengeId: $challengeId)
}
`

export const ADMIN_SYNC_MISSING_CHALLENGE_CLIP_VIEWS = gql`
mutation AdminSyncMissingChallengeClipViews($challengeId: ID!) {
  adminSyncMissingChallengeClipViews(challengeId: $challengeId)
}
`

export const ADMIN_FORCE_UPDATE_CHALLENGE_CLIP_VIEWS = gql`
mutation AdminForceUpdateChallengeClipViews($clipIds: [ID!]!) {
  adminForceUpdateChallengeClipViews(clipIds: $clipIds)
}
`

export const ADMIN_FORCE_UPDATE_CHALLENGE_CLIP_VIEW = gql`
mutation AdminForceUpdateChallengeClipView($clipId: ID!) {
  adminForceUpdateChallengeClipView(clipId: $clipId)
}
`

// ==================== CPM Campaigns ====================

export const COMMUNITY_LIBRARIES_WITH_CAMPAIGNS = gql`
  query CommunityLibrariesWithCampaigns(
    $limit: Int, $offset: Int, $search: String, $channelId: ID,
    $channelCategory: String, $sort: String, $tagId: ID, $language: String,
    $campaignId: ID
  ) {
    communityLibraries(
      limit: $limit, offset: $offset, search: $search, channelId: $channelId,
      channelCategory: $channelCategory, sort: $sort, tagId: $tagId,
      language: $language, campaignId: $campaignId
    ) {
      id
      name
      curation_status
      base_video_url
      compressed_base_video_url
      original_video_url
      cut_video_url
      format
      language
      duration_seconds
      start_time
      end_time
      thumbnail_url
      youtube_video_id
      view_count
      upload_date
      remix_count
      windowed_remix_count
      createdAt
      created_by_user_name
      youtube_channels { channel_id name thumbnail }
      active_cpm_campaigns {
        campaign_type ranking_config
        id
        name
        cpm_rate_cents
        cpm_platform_rates { platform cpm_rate_cents }
        allowed_platforms
        currency
        budget_total_cents
        budget_remaining_cents
        budget_pending_cents
        invite_only
        # selected_only only — deliberately NOT is_selected_user. This nested
        # selection resolves through MyLibrary.active_cpm_campaigns, whose
        # is_selected_user field resolver re-fetches the campaign per row
        # (the enriched myCpmCampaigns path computes it inline instead). The
        # strip only needs to label the campaign as selected-only, so skipping
        # the per-viewer flag here avoids an N+1 on the community grid.
        selected_only
        my_approved_platforms
      }
    }
  }
`

export const MY_CPM_CAMPAIGN = gql`
  query MyCpmCampaign($id: ID!) {
    myCpmCampaign(id: $id) {
      campaign_type ranking_config
      id name description status start_date end_date currency
      banner_url categories
      cpm_rate_cents budget_total_cents budget_remaining_cents budget_pending_cents
      cpm_platform_rates { platform cpm_rate_cents }
      min_views_threshold min_payout_per_clipper_cents max_payout_per_clipper_cents
      max_payout_per_clip_cents
      view_accrual_window_hours
      required_hashtags required_mention min_clip_duration_seconds allowed_platforms rules_allowed rules_forbidden rules_attention rules_warning
      caption_examples
      enforced_post_layout
      requires_channel_approval
      invite_only
      selected_only
      is_selected_user
      editing_assets
      my_approved_platforms
      is_joined
      join_blocked_reason
      my_channel_requests {
        id
        platform
        submitted_url
        handle
        status
        review_reason
        reviewed_at
        createdAt
        youtube_channel { id name handle thumbnail subscriber_count }
      }
      youtube_channels { channel_id name thumbnail }
      library_projects { id name thumbnail_url }
      participating_libraries {
        id
        active_cpm_campaigns { id }
        name
        thumbnail_url
        duration_seconds
        aired_at
        view_count
        youtube_video_id
        youtube_download_id
        base_video_url
        original_video_url
        cut_video_url
        compressed_base_video_url
        format
        language
        start_time
        end_time
        youtube_channels { channel_id name thumbnail }
      }
      my_submissions {
        id platform url admin_approval validated_hashtags disqualified
        last_counted_views accumulated_payout_cents cpm_rate_override_cents last_view_sync_at latest_views payable_views
        approval_reason disqualification_reason admin_observation suspected_duplicate
        social_connection_id provider_media_id metrics_source metrics_status metrics_error
        disapproved_at
        pre_approval pre_approval_score pre_approval_at rules_check_failures estimated_payout_cents
        media_duration_seconds
        rules_check_missing_hashtags rules_check_missing_mentions
        appeal { id status argument extra_url evidence_image_urls reviewer_reply reviewer_images { url visibility } original_approval_reason createdAt }
        rejection_images { url visibility }
        createdAt
      }
      my_total_earnings_cents
    }
  }
`

export const MY_SOCIAL_LINKING_PLATFORMS = gql`
  query MySocialLinkingPlatforms {
    mySocialLinkingPlatforms
  }
`

export const MY_SOCIAL_POSTING_PLATFORMS = gql`
  query MySocialPostingPlatforms {
    mySocialPostingPlatforms
  }
`

export const MY_SOCIAL_CONNECTIONS = gql`
  query MySocialConnections {
    mySocialConnections {
      id
      platform
      username
      display_name
      avatar_url
      status
      scopes
      access_expires_at
      last_synced_at
      createdAt
    }
  }
`

export const RESOLVE_MY_CPM_OWNED_MEDIA = gql`
  query ResolveMyCpmOwnedMedia($platform: String!, $url: String!) {
    resolveMyCpmOwnedMedia(platform: $platform, url: $url) {
      social_connection_id
      username
      provider_media_id
    }
  }
`

export const DISCONNECT_MY_SOCIAL_CONNECTION = gql`
  mutation DisconnectMySocialConnection($id: ID!) {
    disconnectMySocialConnection(id: $id)
  }
`

export const CREATE_MY_CPM_CAMPAIGN_SUBMISSION = gql`
  mutation CreateMyCpmCampaignSubmission($input: CreateMyCpmCampaignSubmissionInput!) {
    createMyCpmCampaignSubmission(input: $input) {
      id platform url admin_approval accumulated_payout_cents createdAt
    }
  }
`

export const DELETE_MY_CPM_CAMPAIGN_SUBMISSION = gql`
  mutation DeleteMyCpmCampaignSubmission($id: ID!) {
    deleteMyCpmCampaignSubmission(id: $id)
  }
`

export const CREATE_MY_CPM_CAMPAIGN_SUBMISSION_APPEAL = gql`
  mutation CreateMyCpmCampaignSubmissionAppeal(
    $submissionId: ID!
    $argument: String!
    $extraUrl: String
    $evidenceImageUrls: [String!]
  ) {
    createMyCpmCampaignSubmissionAppeal(
      submissionId: $submissionId
      argument: $argument
      extraUrl: $extraUrl
      evidenceImageUrls: $evidenceImageUrls
    ) {
      id status argument extra_url evidence_image_urls reviewer_reply reviewer_images { url visibility } createdAt
    }
  }
`

export const RESPOND_TO_MY_CPM_CAMPAIGN_SUBMISSION_APPEAL = gql`
  mutation RespondToMyCpmCampaignSubmissionAppeal(
    $id: ID!
    $argument: String!
    $extraUrl: String
    $evidenceImageUrls: [String!]
  ) {
    respondToMyCpmCampaignSubmissionAppeal(
      id: $id
      argument: $argument
      extraUrl: $extraUrl
      evidenceImageUrls: $evidenceImageUrls
    ) {
      id status argument extra_url evidence_image_urls reviewer_reply reviewer_images { url visibility } createdAt
    }
  }
`

export const JOIN_CPM_CAMPAIGN = gql`
  mutation JoinCpmCampaign($campaignId: ID!) {
    joinCpmCampaign(campaignId: $campaignId)
  }
`

export const LEAVE_CPM_CAMPAIGN = gql`
  mutation LeaveCpmCampaign($campaignId: ID!) {
    leaveCpmCampaign(campaignId: $campaignId)
  }
`

export const ADMIN_CPM_CAMPAIGNS = gql`
  query AdminCpmCampaigns($status: String, $limit: Int, $offset: Int) {
    adminCpmCampaigns(status: $status, limit: $limit, offset: $offset) {
      data {
        campaign_type ranking_config
        id name status currency cpm_rate_cents budget_total_cents
        cpm_platform_rates { platform cpm_rate_cents }
        allowed_platforms
        budget_spent_cents budget_stored_spent_cents budget_spend_drift_cents
        budget_remaining_cents budget_pending_cents
        submissions_count createdAt start_date end_date
        requires_channel_approval
        pending_channel_requests_count
      }
      total
    }
  }
`

export const ADMIN_CPM_CAMPAIGN = gql`
  query AdminCpmCampaign($id: ID!) {
    adminCpmCampaign(id: $id) {
      campaign_type ranking_config
      id name logo_url banner_url categories description status start_date end_date currency
      cpm_rate_cents budget_total_cents
      cpm_platform_rates { platform cpm_rate_cents }
      budget_spent_cents budget_stored_spent_cents budget_spend_drift_cents
      budget_remaining_cents budget_pending_cents
      min_views_threshold min_payout_per_clipper_cents max_payout_per_clipper_cents
      max_payout_per_clip_cents
      view_accrual_window_hours
      required_hashtags required_mention min_clip_duration_seconds allowed_platforms rules_allowed rules_forbidden rules_attention rules_warning
      caption_examples
      requires_channel_approval
      restrict_to_listed_videos
      pre_approval_enabled
      pre_approval_min_score
      rank_min_finished_renders
      invite_only
      selected_only
      watermark_image_url watermark_anchor watermark_size_percent watermark_opacity_percent watermark_margin_x_percent watermark_margin_y_percent
      enforced_post_layout
      enforced_subtitle_position
      editing_assets
      allow_cpm_override cpm_override_mode cpm_override_presets_cents cpm_override_min_cents cpm_override_max_cents
      pending_channel_requests_count
      pending_appeals_count
      youtube_channels { id channel_id name thumbnail }
      library_projects { id name thumbnail_url }
      youtube_downloads {
        id
        video_id
        name
        thumbnail_url
        youtube_channels { id channel_id name thumbnail }
      }
      excluded_youtube_downloads { id video_id name thumbnail_url }
      campaign_admins { id email name }
      selected_users { id email name }
      submissions_count createdAt updatedAt
    }
  }
`

export const MY_AUDITED_CPM_CAMPAIGNS = gql`
  query MyAuditedCpmCampaigns {
    adminCpmCampaigns(limit: 100, offset: 0) {
      data {
        campaign_type ranking_config
        id
        name
        description
        status
        logo_url
        banner_url
        categories
        start_date
        currency
        cpm_rate_cents
        cpm_platform_rates { platform cpm_rate_cents }
        allowed_platforms
        max_payout_per_clip_cents
        budget_total_cents
        budget_spent_cents
        budget_stored_spent_cents
        budget_spend_drift_cents
        budget_remaining_cents
        budget_pending_cents
        submissions_count
        pending_submissions_count
        approved_submissions_count
        disapproved_submissions_count
        pending_appeals_count
        pending_channel_requests_count
        youtube_channels {
          id
          name
          handle
          thumbnail
        }
        createdAt
      }
      total
    }
  }
`

export const ACTIVE_CPM_CAMPAIGN_CHANNELS = gql`
  query ActiveCpmCampaignChannels {
    myCpmCampaigns(status: "active", includeInviteOnlyTeasers: true) {
      campaign_type ranking_config
      id
      name
      required_hashtags
      logo_url
      banner_url
      categories
      invite_only
      selected_only
      is_selected_user
      my_approved_platforms
      cpm_rate_cents
      cpm_platform_rates { platform cpm_rate_cents }
      allowed_platforms
      min_views_threshold
      currency
      budget_total_cents
      budget_remaining_cents
      budget_pending_cents
      youtube_channels {
        channel_id
        thumbnail
      }
    }
  }
`

export const EARN_PAGE_CAMPAIGNS = gql`
  query EarnPageCampaigns {
    myCpmCampaigns(status: "active", includeInviteOnlyTeasers: true) {
      campaign_type ranking_config
      id
      name
      logo_url
      banner_url
      categories
      cpm_rate_cents
      cpm_platform_rates { platform cpm_rate_cents }
      allowed_platforms
      min_views_threshold
      currency
      budget_total_cents
      budget_remaining_cents
      budget_pending_cents
      required_hashtags
      invite_only
      selected_only
      is_selected_user
      my_approved_platforms
      is_joined
      join_blocked_reason
      youtube_channels {
        channel_id
        name
        thumbnail
        category
        is_autoclipper_partner
      }
    }
  }
`

export const CPM_CLIPPER_LEADERBOARD = gql`
  query CpmClipperLeaderboard {
    cpmClipperLeaderboard {
      user_id
      name
      avatar_url
      total_views
      video_count
      anonymous
      views_tier_id
      families { id featured_tier_id badges { tier_id season_id season_name } }
    }
  }
`

export const MY_CPM_LEADERBOARD_STANDING = gql`
  query MyCpmLeaderboardStanding {
    myCpmLeaderboardStanding {
      rank
      total
      entries {
        rank
        is_viewer
        user_id
        name
        avatar_url
        total_views
        video_count
        anonymous
        views_tier_id
        families { id featured_tier_id badges { tier_id season_id season_name } }
      }
    }
  }
`

export const MY_CPM_LEADERBOARD_VIEWER = gql`
  query MyCpmLeaderboardViewer {
    myData {
      id
      name
      profile_picture
      onboarding_objective
    }
  }
`

export const MY_CPM_LEADERBOARD_PRIVACY = gql`
  query MyCpmLeaderboardPrivacy {
    myCpmLeaderboardPrivacy {
      anonymous
      can_remain_anonymous
    }
  }
`

export const SET_MY_CPM_LEADERBOARD_ANONYMOUS = gql`
  mutation SetMyCpmLeaderboardAnonymous($anonymous: Boolean!) {
    setMyCpmLeaderboardAnonymous(anonymous: $anonymous) {
      anonymous
      can_remain_anonymous
    }
  }
`

export const EARN_PAGE_ENDED_CAMPAIGNS = gql`
  query EarnPageEndedCampaigns {
    myCpmCampaigns(status: "ended") {
      campaign_type ranking_config
      id
      name
      logo_url
      banner_url
      categories
      currency
      budget_total_cents
      budget_remaining_cents
      youtube_channels {
        channel_id
        name
        thumbnail
      }
    }
  }
`

// Scheduled cards are non-clickable /earn teasers. Opt into restricted
// campaigns so free users can see invite-only and selected-only announcements;
// the backend hides those rows by default on non-teaser surfaces.
export const EARN_PAGE_SCHEDULED_CAMPAIGNS = gql`
  query EarnPageScheduledCampaigns {
    myCpmCampaigns(status: "scheduled", includeInviteOnlyTeasers: true) {
      campaign_type ranking_config
      id
      name
      logo_url
      banner_url
      categories
      currency
      cpm_rate_cents
      start_date
      budget_total_cents
      youtube_channels {
        channel_id
        name
        thumbnail
      }
    }
  }
`

export const CAMPAIGN_CHANNEL_PICKER = gql`
  query CampaignChannelPicker($search: String) {
    communityChannels(search: $search) {
      id
      channel_id
      name
      thumbnail
    }
  }
`

export const CAMPAIGN_LIBRARY_PICKER = gql`
  query CampaignLibraryPicker($search: String, $channelId: ID, $limit: Int) {
    communityLibraries(
      search: $search, channelId: $channelId, limit: $limit,
      expandCampaignChannel: false
    ) {
      id
      name
      thumbnail_url
      youtube_download_id
      youtube_channels {
        channel_id
        name
      }
    }
  }
`

export const CAMPAIGN_ADMIN_USER_PICKER = gql`
  query CampaignAdminUserPicker($search: String, $pageSize: Int) {
    adminUsers(search: $search, pageSize: $pageSize, page: 1) {
      data {
        id
        name
        email
      }
    }
  }
`

export const ADMIN_CPM_CAMPAIGN_SUBMISSIONS = gql`
  query AdminCpmCampaignSubmissions(
    $campaignId: ID!
    $approval: String
    $search: String
    $limit: Int
    $offset: Int
    $suspectedDuplicatesOnly: Boolean
    $platform: String
    $validatedHashtags: String
    $pendingOlderThanHours: Int
  ) {
    adminCpmCampaignSubmissions(
      campaignId: $campaignId
      approval: $approval
      search: $search
      limit: $limit
      offset: $offset
      suspectedDuplicatesOnly: $suspectedDuplicatesOnly
      platform: $platform
      validatedHashtags: $validatedHashtags
      pendingOlderThanHours: $pendingOlderThanHours
    ) {
      data {
        id platform url admin_approval validated_hashtags disqualified
        last_counted_views accumulated_payout_cents cpm_rate_override_cents last_view_sync_at latest_views
        approval_reason disqualification_reason admin_observation
        rejection_images { url visibility }
        user_disqualified
        user_id user_email user_name createdAt
        pending_appeal_id
        disapproved_at
        daily_views { date views likes comments shares }
        suspected_duplicate
        suspected_duplicate_reason
        video_hash
        canonical_url
        content_review_group_id
        content_review_group_decision
        accrual_window_ends_at
        final_accrual_views
        final_accrual_captured_at
        final_accrual_source
        account_reliability {
          status score engagement_rate lifetime_views tracked_content username
        }
        metrics_status
        metrics_error
        pre_approval pre_approval_score pre_approval_at rules_check_failures estimated_payout_cents
        media_duration_seconds
        pre_approval_gates rules_check
      }
      total
      pageCount
    }
  }
`

// Deliberately split from the rows query above. `stats` is campaign-global —
// the backend has to aggregate every eligible submission of the campaign to
// build it — while the rows are one cheap paginated page. Keeping them in one
// document made paging, filtering, and every post-save refetch pay the
// aggregate cost. Split, the rows refetch is nearly free and the aggregate is
// only re-read when an action can actually have moved it (see
// `resolveSubmissionRefreshPlan`).
//
// `limit: 1` because this document selects no rows; the backend still runs the
// page query, so asking for 50 unread rows would be waste. The differing args
// also give it its own cache entry, independent of the list's filters.
export const ADMIN_CPM_CAMPAIGN_SUBMISSION_STATS = gql`
  query AdminCpmCampaignSubmissionStats($campaignId: ID!) {
    adminCpmCampaignSubmissions(campaignId: $campaignId, limit: 1, offset: 0) {
      stats {
        total_views
        approved_views
        paid_views
        total_earnings_cents
        total_submissions
        daily_series {
          date
          total_views
          approved_paid_views
          approved_unpaid_views
          clip_count
        }
      }
    }
  }
`

// The full top-earning ranking, one page at a time (replaces the bounded top 10
// that used to ride on `stats.top_earning_clips`). Refetched alongside the
// stats whenever an action can move campaign money.
export const ADMIN_CPM_CAMPAIGN_TOP_EARNING_CLIPS = gql`
  query AdminCpmCampaignTopEarningClips($campaignId: ID!, $limit: Int, $offset: Int) {
    adminCpmCampaignTopEarningClips(campaignId: $campaignId, limit: $limit, offset: $offset) {
      data {
        id
        platform
        url
        user_name
        user_email
        views
        earnings_cents
      }
      total
      pageCount
    }
  }
`

export const ADMIN_ENQUEUE_CPM_SUBMISSION_MEDIA_DOWNLOAD = gql`
  mutation AdminEnqueueCpmSubmissionMediaDownload($submissionId: ID!) {
    adminEnqueueCpmSubmissionMediaDownload(submissionId: $submissionId) {
      id
      submission_id
      status
      provider
      video_url
      error
    }
  }
`

export const ADMIN_CPM_SUBMISSION_MEDIA_DOWNLOAD = gql`
  query AdminCpmSubmissionMediaDownload($submissionId: ID!) {
    adminCpmSubmissionMediaDownload(submissionId: $submissionId) {
      id
      submission_id
      status
      provider
      video_url
      error
    }
  }
`

export const ADMIN_CREATE_CPM_CAMPAIGN = gql`
  mutation AdminCreateCpmCampaign($input: AdminCpmCampaignInput!) {
    adminCreateCpmCampaign(input: $input) { id name logo_url banner_url categories status watermark_image_url watermark_anchor watermark_size_percent watermark_opacity_percent watermark_margin_x_percent watermark_margin_y_percent enforced_post_layout enforced_subtitle_position editing_assets }
  }
`

// Removes one video from a campaign (excluded: true) or restores it. Wins over
// the campaign's listing and attached channels. Admin only.
export const ADMIN_SET_CPM_CAMPAIGN_VIDEO_EXCLUDED = gql`
  mutation AdminSetCpmCampaignVideoExcluded($campaignId: ID!, $videoId: ID!, $excluded: Boolean!) {
    adminSetCpmCampaignVideoExcluded(campaignId: $campaignId, videoId: $videoId, excluded: $excluded)
  }
`

export const ADMIN_UPDATE_CPM_CAMPAIGN = gql`
  mutation AdminUpdateCpmCampaign($id: ID!, $input: AdminCpmCampaignInput!) {
    adminUpdateCpmCampaign(id: $id, input: $input) { id name logo_url banner_url categories status watermark_image_url watermark_anchor watermark_size_percent watermark_opacity_percent watermark_margin_x_percent watermark_margin_y_percent enforced_post_layout enforced_subtitle_position editing_assets }
  }
`

export const ADMIN_DELETE_CPM_CAMPAIGN = gql`
  mutation AdminDeleteCpmCampaign($id: ID!, $force: Boolean) {
    adminDeleteCpmCampaign(id: $id, force: $force)
  }
`

export const ADMIN_RECOMPUTE_CPM_CAMPAIGN_PAYOUTS = gql`
  mutation AdminRecomputeCpmCampaignPayouts($campaignId: ID!) {
    adminRecomputeCpmCampaignPayouts(campaignId: $campaignId) {
      recomputed_count
      changed_count
      total_delta_cents
    }
  }
`

export const ADMIN_REVIEW_CPM_CAMPAIGN_SUBMISSION = gql`
  mutation AdminReviewCpmCampaignSubmission($id: ID!, $approval: String!, $reason: String, $images: [CpmReviewImageInput!]) {
    adminReviewCpmCampaignSubmission(id: $id, approval: $approval, reason: $reason, images: $images) {
      # Every row field a review can move. The backend recomputes the payout
      # before returning, so selecting these lets Apollo's normalized cache
      # update the row and spares the page a full list refetch.
      # pending_appeal_id clears the Contestando badge after approve/auto-close
      # (sanitizeAdmin returns null unless a pending appeal id is passed).
      id admin_approval approval_reason
      rejection_images { url visibility }
      accumulated_payout_cents
      disqualified disqualification_reason
      last_counted_views latest_views
      pending_appeal_id
    }
  }
`

export const ADMIN_LINK_CPM_SUBMISSION_CONTENT = gql`
  mutation AdminLinkCpmSubmissionContent($submissionIds: [ID!]!, $reason: String) {
    adminLinkCpmSubmissionContent(submissionIds: $submissionIds, reason: $reason) {
      id
      decision
      decision_reason
      submission_ids
    }
  }
`

export const ADMIN_SET_CPM_CAMPAIGN_SUBMISSION_OBSERVATION = gql`
  mutation AdminSetCpmCampaignSubmissionObservation($id: ID!, $observation: String) {
    adminSetCpmCampaignSubmissionObservation(id: $id, observation: $observation) {
      id
      admin_observation
    }
  }
`

export const ADMIN_SET_CPM_CAMPAIGN_SUBMISSION_CPM_OVERRIDE = gql`
  mutation AdminSetCpmCampaignSubmissionCpmOverride($id: ID!, $cpm_rate_cents: Int) {
    adminSetCpmCampaignSubmissionCpmOverride(id: $id, cpm_rate_cents: $cpm_rate_cents) {
      id
      cpm_rate_override_cents
      accumulated_payout_cents
      last_counted_views
      latest_views
    }
  }
`

export const ADMIN_RESOLVE_SUSPECTED_DUPLICATE = gql`
  mutation AdminResolveSuspectedDuplicate($id: ID!, $action: String!) {
    adminResolveSuspectedDuplicate(id: $id, action: $action) {
      id
      suspected_duplicate
      suspected_duplicate_reason
      disqualified
      disqualification_reason
      accumulated_payout_cents
    }
  }
`

export const ADMIN_DISQUALIFY_CPM_CAMPAIGN_SUBMISSION = gql`
  mutation AdminDisqualifyCpmCampaignSubmission($id: ID!, $reason: String!) {
    adminDisqualifyCpmCampaignSubmission(id: $id, reason: $reason) {
      id disqualified disqualification_reason
    }
  }
`

export const ADMIN_CPM_CAMPAIGN_PARTICIPANTS = gql`
  query AdminCpmCampaignParticipants(
    $campaignId: ID!
    $search: String
    $disqualifiedOnly: Boolean
    $limit: Int
    $offset: Int
  ) {
    adminCpmCampaignParticipants(
      campaignId: $campaignId
      search: $search
      disqualifiedOnly: $disqualifiedOnly
      limit: $limit
      offset: $offset
    ) {
      data {
        user_id
        user_name
        user_email
        submission_count
        approved_count
        total_views
        total_earnings_cents
        disqualified
        disqualification_reason
        disqualification_id
        first_submitted_at
      }
      total
      pageCount
    }
  }
`

export const ADMIN_DISQUALIFY_CPM_CAMPAIGN_USER = gql`
  mutation AdminDisqualifyCpmCampaignUser(
    $campaignId: ID!
    $userId: ID!
    $reason: String!
  ) {
    adminDisqualifyCpmCampaignUser(
      campaignId: $campaignId
      userId: $userId
      reason: $reason
    ) {
      id
      user_id
      reason
      createdAt
      reclaimed_cents
    }
  }
`

export const ADMIN_UNDISQUALIFY_CPM_CAMPAIGN_USER = gql`
  mutation AdminUndisqualifyCpmCampaignUser($campaignId: ID!, $userId: ID!) {
    adminUndisqualifyCpmCampaignUser(campaignId: $campaignId, userId: $userId)
  }
`

export const ADMIN_FORCE_UPDATE_CPM_CAMPAIGN_SUBMISSION_VIEW = gql`
  mutation AdminForceUpdateCpmCampaignSubmissionView($id: ID!) {
    adminForceUpdateCpmCampaignSubmissionView(id: $id)
  }
`

export const ADMIN_FORCE_UPDATE_ALL_CPM_CAMPAIGN_SUBMISSION_VIEWS = gql`
  mutation AdminForceUpdateAllCpmCampaignSubmissionViews($campaignId: ID!) {
    adminForceUpdateAllCpmCampaignSubmissionViews(campaignId: $campaignId)
  }
`

export const ADMIN_SYNC_MISSING_CPM_CAMPAIGN_SUBMISSION_VIEWS = gql`
  mutation AdminSyncMissingCpmCampaignSubmissionViews($campaignId: ID!) {
    adminSyncMissingCpmCampaignSubmissionViews(campaignId: $campaignId)
  }
`

export const ADMIN_SET_CPM_CAMPAIGN_SUBMISSION_HASHTAG_VALIDATION = gql`
  mutation AdminSetCpmCampaignSubmissionHashtagValidation($id: ID!, $validated_hashtags: String!) {
    adminSetCpmCampaignSubmissionHashtagValidation(id: $id, validated_hashtags: $validated_hashtags)
  }
`

export const ADMIN_CPM_CAMPAIGN_SUBMISSION_APPEALS = gql`
  query AdminCpmCampaignSubmissionAppeals($campaignId: ID!, $status: String, $limit: Int, $offset: Int) {
    adminCpmCampaignSubmissionAppeals(campaignId: $campaignId, status: $status, limit: $limit, offset: $offset) {
      data {
        id submission_id user_name user_email platform url argument extra_url evidence_image_urls
        status original_approval_reason reviewer_reply reviewer_images { url visibility } createdAt reviewed_at
      }
      total pageCount
    }
  }
`

export const ADMIN_REVIEW_CPM_CAMPAIGN_SUBMISSION_APPEAL = gql`
  mutation AdminReviewCpmCampaignSubmissionAppeal($id: ID!, $decision: String!, $reply: String, $images: [CpmReviewImageInput!]) {
    adminReviewCpmCampaignSubmissionAppeal(id: $id, decision: $decision, reply: $reply, images: $images) {
      id status reviewer_reply reviewer_images { url visibility } reviewed_at submission_id
    }
  }
`

export const ADMIN_BULK_REVIEW_CPM_CAMPAIGN_SUBMISSIONS = gql`
  mutation AdminBulkReviewCpmCampaignSubmissions($ids: [ID!]!) {
    adminBulkReviewCpmCampaignSubmissions(ids: $ids) {
      approved
      skipped { id code }
    }
  }
`

// One reason (and images) for every selected pending clip, in one request.
export const ADMIN_BULK_DISAPPROVE_CPM_CAMPAIGN_SUBMISSIONS = gql`
  mutation AdminBulkDisapproveCpmCampaignSubmissions(
    $ids: [ID!]!
    $reason: String!
    $images: [CpmReviewImageInput!]
  ) {
    adminBulkDisapproveCpmCampaignSubmissions(ids: $ids, reason: $reason, images: $images) {
      disapproved
      skipped { id code }
    }
  }
`

export const MY_CPM_WALLET = gql`
  query MyCpmWallet {
    myCpmWallet {
      total_earned_cents
      total_paid_out_cents
      pending_cents
      pending_payout_cents
      affiliate_pending_cents
      available_cents
      affiliate_earned_cents
      producer_earned_cents
      currency
      pending_kind
      per_campaign_breakdown {
        campaign_id
        campaign_name
        earned_cents
      }
    }
  }
`;

export const AFFILIATE_STATUS_FIELDS = gql`
  fragment AffiliateStatusFields on MyAffiliateStatus {
    joined
    blocked
    blocked_reason
    code
    custom_code
    total_referred
    terms_current_version
    totals {
      total_earned_cents
      pending_cents
      released_cents
      payment_cents
      course_cents
      cpm_cents
    }
    rates {
      payment
      course
      cpm
    }
    earnings {
      id
      amount_cents
      commission_rate
      status
      source
      payment_date
      payment_amount_cents
      referred_user_name
      createdAt
      releases_at
    }
    referred_users {
      id
      name
      createdAt
      has_paid
      total_commission_cents
    }
  }
`;

export const MY_PIX_VERIFICATION = gql`
  query MyPixVerification {
    myPixVerification {
      id
      cpf
      status
      review_reason
      submitted_at
      reviewed_at
      createdAt
    }
  }
`;

export const SUBMIT_MY_PIX_VERIFICATION = gql`
  mutation SubmitMyPixVerification(
    $cpf: String!
    $document_url: String!
    $document_back_url: String
  ) {
    submitMyPixVerification(
      cpf: $cpf
      document_url: $document_url
      document_back_url: $document_back_url
    ) {
      id
      cpf
      status
      review_reason
      submitted_at
      reviewed_at
      createdAt
    }
  }
`;

export const ADMIN_PIX_VERIFICATIONS = gql`
  query AdminPixVerifications($status: String, $search: String, $limit: Int, $offset: Int) {
    adminPixVerifications(status: $status, search: $search, limit: $limit, offset: $offset) {
      data {
        id
        cpf
        status
        review_reason
        submitted_at
        reviewed_at
        createdAt
        document_url
        document_back_url
        user_id
        user_email
        user_name
        reviewed_by_id
        reviewed_by_name
      }
      total
      pageCount
    }
  }
`;

// Minted on demand, at click time: the presigned read URL has a 5-minute TTL on
// the backend, so one baked into the list response is dead by the time an admin
// working through the queue gets to that row.
export const ADMIN_PIX_VERIFICATION_DOCUMENT_URL = gql`
  query AdminPixVerificationDocumentUrl($id: ID!, $side: String) {
    adminPixVerificationDocumentUrl(id: $id, side: $side)
  }
`;

export const ADMIN_REVIEW_PIX_VERIFICATION = gql`
  mutation AdminReviewPixVerification($id: ID!, $status: String!, $reason: String) {
    adminReviewPixVerification(id: $id, status: $status, reason: $reason) {
      id
      status
      review_reason
      reviewed_at
      reviewed_by_id
      reviewed_by_name
    }
  }
`;

export const MY_AFFILIATE_STATUS = gql`
  ${AFFILIATE_STATUS_FIELDS}
  query MyAffiliateStatus {
    myAffiliateStatus {
      ...AffiliateStatusFields
    }
  }
`;

export const ACCEPT_AFFILIATE_TERMS = gql`
  ${AFFILIATE_STATUS_FIELDS}
  mutation AcceptAffiliateTerms($version: String!) {
    acceptAffiliateTerms(version: $version) {
      ...AffiliateStatusFields
    }
  }
`;

export const SET_MY_AFFILIATE_CUSTOM_CODE = gql`
  ${AFFILIATE_STATUS_FIELDS}
  mutation SetMyAffiliateCustomCode($code: String!) {
    setMyAffiliateCustomCode(code: $code) {
      ...AffiliateStatusFields
    }
  }
`;

export const MY_AFFILIATE_REFERRED_USER_EARNINGS = gql`
  query MyAffiliateReferredUserEarnings($userId: ID!) {
    myAffiliateReferredUserEarnings(userId: $userId) {
      id
      date
      description
      source
      payment_amount_cents
      commission_cents
      commission_rate
      status
    }
  }
`;

export const CLAIM_REFERRAL_ATTRIBUTION = gql`
  mutation ClaimReferralAttribution($code: String!) {
    claimReferralAttribution(code: $code)
  }
`;

export const ADMIN_AFFILIATE_EARNINGS = gql`
  query AdminAffiliateEarnings($search: String, $kind: String, $limit: Int, $offset: Int) {
    adminAffiliateEarnings(search: $search, kind: $kind, limit: $limit, offset: $offset) {
      data {
        id
        kind
        course_id
        course_title
        user_id
        user_email
        user_name
        referred_user_email
        referred_user_name
        amount_cents
        commission_rate
        status
        source
        payment_date
        payment_amount_cents
        payment_provider
        reversal_note
        createdAt
      }
      total
    }
  }
`;

export const ADMIN_COURSE_REVENUE_SHARES = gql`
  query AdminCourseRevenueShares($courseId: ID, $active: Boolean) {
    adminCourseRevenueShares(courseId: $courseId, active: $active) {
      id
      course_id
      course_title
      user_id
      user_email
      user_name
      rate_percent
      active
      note
      createdAt
      updatedAt
      totals {
        accrued_cents
        pending_cents
        available_cents
        reversed_cents
      }
    }
  }
`;

export const ADMIN_UPSERT_COURSE_REVENUE_SHARE = gql`
  mutation AdminUpsertCourseRevenueShare($id: ID, $input: AdminCourseRevenueShareInput!) {
    adminUpsertCourseRevenueShare(id: $id, input: $input) {
      id
      course_id
      course_title
      user_id
      user_email
      user_name
      rate_percent
      active
      note
      createdAt
      updatedAt
      totals {
        accrued_cents
        pending_cents
        available_cents
        reversed_cents
      }
    }
  }
`;

export const ADMIN_SET_COURSE_REVENUE_SHARE_ACTIVE = gql`
  mutation AdminSetCourseRevenueShareActive($id: ID!, $active: Boolean!) {
    adminSetCourseRevenueShareActive(id: $id, active: $active) {
      id
      active
      updatedAt
    }
  }
`;

export const MY_COURSE_ROYALTIES = gql`
  query MyCourseRoyalties($limit: Int, $after: String) {
    myCourseRoyalties(limit: $limit, after: $after) {
      configurations {
        id
        course_id
        course_title
        rate_percent
        active
      }
      earnings {
        id
        course_id
        course_title
        sale_date
        gross_amount_cents
        royalty_cents
        rate_percent
        status
        releases_at
      }
      earnings_page_info {
        has_more
        next_cursor
      }
      accrued_cents
      pending_cents
      available_cents
      reversed_cents
    }
  }
`;

export const ADMIN_REVERSE_AFFILIATE_EARNING = gql`
  mutation AdminReverseAffiliateEarning($id: ID!, $note: String) {
    adminReverseAffiliateEarning(id: $id, note: $note)
  }
`;

export const REQUEST_CPM_PAYOUT = gql`
  mutation RequestCpmPayout($input: RequestCpmPayoutInput!) {
    requestCpmPayout(input: $input) {
      id
      status
      amount_cents
      currency
      requested_at
    }
  }
`;

export const ADMIN_CPM_PAYOUTS = gql`
  query AdminCpmPayouts($search: String, $userId: ID, $kind: String, $limit: Int, $offset: Int) {
    adminCpmPayouts(search: $search, userId: $userId, kind: $kind, limit: $limit, offset: $offset) {
      data {
        id
        user_id
        user_email
        user_name
        amount_cents
        currency
        status
        note
        paid_at
        requested_at
        bank_data
        breakdown
        kind
        redemption_data
        created_by_email
        createdAt
        pix_verification_status
        pix_verification_review_reason
      }
      total
    }
  }
`;

export const REDEEM_WALLET_FOR_PLAN = gql`
  mutation RedeemWalletForPlan($planId: ID!, $yearly: Boolean, $remainderMethod: String, $document: JSON, $coupon: String) {
    redeemWalletForPlan(planId: $planId, yearly: $yearly, remainderMethod: $remainderMethod, document: $document, coupon: $coupon) {
      status
      checkout
      payoutDocumentId
    }
  }
`;

export const CANCEL_MY_WALLET_REDEMPTION_HOLD = gql`
  mutation CancelMyWalletRedemptionHold {
    cancelMyWalletRedemptionHold
  }
`;

export const REDEEM_WALLET_FOR_EXTRA_MINUTES = gql`
  mutation RedeemWalletForExtraMinutes($minutes: Int!, $remainderMethod: String, $document: JSON, $returnUrl: String) {
    redeemWalletForExtraMinutes(minutes: $minutes, remainderMethod: $remainderMethod, document: $document, returnUrl: $returnUrl) {
      status
      checkout
      payoutDocumentId
    }
  }
`;

export const RENEW_PLAN_WITH_WALLET = gql`
  mutation RenewPlanWithWallet($remainderMethod: String, $document: JSON, $returnUrl: String) {
    renewPlanWithWallet(remainderMethod: $remainderMethod, document: $document, returnUrl: $returnUrl) {
      status
      checkout
      payoutDocumentId
    }
  }
`;

export const ADMIN_APPROVE_CPM_PAYOUT = gql`
  mutation AdminApproveCpmPayout($id: ID!) {
    adminApproveCpmPayout(id: $id) {
      id
      status
      paid_at
    }
  }
`;

export const ADMIN_USER_CPM_WALLET = gql`
  query AdminUserCpmWallet($userId: ID!) {
    adminUserCpmWallet(userId: $userId) {
      user_id
      total_earned_cents
      total_paid_out_cents
      available_cents
      currency
      payouts {
        id
        amount_cents
        currency
        note
        paid_at
        created_by_email
        createdAt
      }
    }
  }
`;

export const ADMIN_CREATE_CPM_PAYOUT = gql`
  mutation AdminCreateCpmPayout($input: AdminCreateCpmPayoutInput!) {
    adminCreateCpmPayout(input: $input) {
      id
      user_id
      user_email
      user_name
      amount_cents
      currency
      status
      note
      paid_at
      requested_at
      created_by_email
      createdAt
    }
  }
`;

export const ADMIN_DELETE_CPM_PAYOUT = gql`
  mutation AdminDeleteCpmPayout($id: ID!) {
    adminDeleteCpmPayout(id: $id)
  }
`;

export const ADMIN_CPM_CAMPAIGN_CHANNEL_REQUESTS = gql`
  query AdminCpmCampaignChannelRequests($campaignId: ID!, $status: String, $search: String, $limit: Int, $offset: Int) {
    adminCpmCampaignChannelRequests(campaignId: $campaignId, status: $status, search: $search, limit: $limit, offset: $offset) {
      total
      pageCount
      data {
        id
        platform
        submitted_url
        handle
        status
        review_reason
        reviewed_at
        createdAt
        user_id
        user_email
        user_name
        reviewed_by_id
        reviewed_by_name
        youtube_channel { id name handle thumbnail subscriber_count }
      }
    }
  }
`;

export const CREATE_MY_CPM_CAMPAIGN_CHANNEL_REQUEST = gql`
  mutation CreateMyCpmCampaignChannelRequest($campaignId: ID!, $platform: String!, $url: String!) {
    createMyCpmCampaignChannelRequest(campaignId: $campaignId, platform: $platform, url: $url) {
      id status platform handle submitted_url
    }
  }
`;

export const DELETE_MY_CPM_CAMPAIGN_CHANNEL_REQUEST = gql`
  mutation DeleteMyCpmCampaignChannelRequest($id: ID!) {
    deleteMyCpmCampaignChannelRequest(id: $id)
  }
`;

export const ADMIN_REVIEW_CPM_CAMPAIGN_CHANNEL_REQUEST = gql`
  mutation AdminReviewCpmCampaignChannelRequest($id: ID!, $status: String!, $reason: String) {
    adminReviewCpmCampaignChannelRequest(id: $id, status: $status, reason: $reason) {
      id status review_reason reviewed_at
    }
  }
`;

export const ADMIN_REVOKE_CPM_CAMPAIGN_CHANNEL_REQUEST = gql`
  mutation AdminRevokeCpmCampaignChannelRequest($id: ID!, $reason: String!) {
    adminRevokeCpmCampaignChannelRequest(id: $id, reason: $reason) {
      id status review_reason reviewed_at
    }
  }
`;

export const ADMIN_INVITE_CPM_CAMPAIGN_USER = gql`
  mutation AdminInviteCpmCampaignUser($campaignId: ID!, $email: String!, $platform: String!, $channelUrl: String!) {
    adminInviteCpmCampaignUser(campaignId: $campaignId, email: $email, platform: $platform, channelUrl: $channelUrl) {
      id status platform handle user_email reviewed_at
    }
  }
`;

export const ADMIN_EMAIL_FLOW_TRIGGERS = gql`
  query AdminEmailFlowTriggers {
    adminEmailFlowTriggers { key label variables }
  }
`;

export const ADMIN_EMAIL_FLOWS = gql`
  query AdminEmailFlows($page: Int, $pageSize: Int, $search: String) {
    adminEmailFlows(page: $page, pageSize: $pageSize, search: $search) {
      data {
        id name slug description trigger is_active is_transactional is_editable audience stepsCount
      }
      total page pageSize
    }
  }
`;

export const ADMIN_EMAIL_FLOW = gql`
  query AdminEmailFlow($id: ID!) {
    adminEmailFlow(id: $id) {
      id name slug description trigger is_active is_transactional is_editable audience stepsCount
      steps { id order delay_minutes subject_pt body_pt subject_en body_en is_active }
    }
  }
`;

export const ADMIN_CREATE_EMAIL_FLOW = gql`
  mutation AdminCreateEmailFlow($input: AdminEmailFlowInput!) {
    adminCreateEmailFlow(input: $input) { id name slug trigger is_active is_transactional is_editable audience stepsCount }
  }
`;

export const ADMIN_UPDATE_EMAIL_FLOW = gql`
  mutation AdminUpdateEmailFlow($id: ID!, $input: AdminEmailFlowUpdateInput!) {
    adminUpdateEmailFlow(id: $id, input: $input) { id name slug description trigger is_active is_transactional is_editable audience stepsCount }
  }
`;

export const ADMIN_DELETE_EMAIL_FLOW = gql`
  mutation AdminDeleteEmailFlow($id: ID!) { adminDeleteEmailFlow(id: $id) }
`;

export const ADMIN_UPSERT_EMAIL_FLOW_STEP = gql`
  mutation AdminUpsertEmailFlowStep($input: AdminEmailFlowStepInput!) {
    adminUpsertEmailFlowStep(input: $input) {
      id order delay_minutes subject_pt body_pt subject_en body_en is_active
    }
  }
`;

export const ADMIN_DELETE_EMAIL_FLOW_STEP = gql`
  mutation AdminDeleteEmailFlowStep($id: ID!) { adminDeleteEmailFlowStep(id: $id) }
`;

export const ADMIN_REORDER_EMAIL_FLOW_STEPS = gql`
  mutation AdminReorderEmailFlowSteps($flowId: ID!, $stepIds: [ID!]!) {
    adminReorderEmailFlowSteps(flowId: $flowId, stepIds: $stepIds) {
      id order delay_minutes subject_pt body_pt subject_en body_en is_active
    }
  }
`;

export const ADMIN_SEND_TEST_EMAIL_FLOW_STEP = gql`
  mutation AdminSendTestEmailFlowStep($stepId: ID!, $locale: String!, $recipientEmail: String!) {
    adminSendTestEmailFlowStep(stepId: $stepId, locale: $locale, recipientEmail: $recipientEmail)
  }
`;

export const ADMIN_EMAIL_FLOW_RUNS = gql`
  query AdminEmailFlowRuns($flowId: ID!, $page: Int, $pageSize: Int) {
    adminEmailFlowRuns(flowId: $flowId, page: $page, pageSize: $pageSize) {
      data { id user_email current_step_order status started_at completed_at sendsCount }
      total page pageSize
    }
  }
`;

export const ADMIN_EMAIL_FLOW_RUN_SENDS = gql`
  query AdminEmailFlowRunSends($runId: ID!) {
    adminEmailFlowRunSends(runId: $runId) {
      id step_id step_order sent_at success error subject_used language_used is_test
    }
  }
`;

export const EFFECTIVE_WATERMARK = gql`
  query EffectiveWatermark($id: ID!) {
    myProject(id: $id) {
      id
      effective_watermark {
        image_url
        anchor
        size_percent
        opacity_percent
        margin_x_percent
        margin_y_percent
      }
      effective_post_layout
      effective_subtitle_position
    }
  }
`;

export const LIBRARY_EFFECTIVE_WATERMARK = gql`
  query LibraryEffectiveWatermark($id: ID!) {
    myLibrary(id: $id) {
      id
      effective_watermark {
        image_url
        anchor
        size_percent
        opacity_percent
        margin_x_percent
        margin_y_percent
      }
      effective_post_layout
      effective_subtitle_position
      active_cpm_campaigns {
        id
      }
    }
  }
`;

export const GET_FILLER_VIDEOS = gql`
query fillerVideos($category: String) {
  fillerVideos(category: $category) {
    id
    name
    categories
    file_url
    file_en_url
    thumbnail_url
  }
}
`

export const GET_FILLER_VIDEO_TAGS = gql`
query fillerVideoTags {
  fillerVideoTags {
    slug
    name
  }
}
`

export const GET_MY_USER_MEDIA = gql`
query myUserMedia($kind: String, $folderId: ID, $search: String, $limit: Int, $offset: Int) {
  myUserMedia(kind: $kind, folderId: $folderId, search: $search, limit: $limit, offset: $offset) {
    id
    url
    kind
    name
    width
    height
    duration
    folder_id
    createdAt
  }
}
`

export const CREATE_MY_USER_MEDIA = gql`
mutation createMyUserMedia($input: MyUserMediaCreateInput!) {
  createMyUserMedia(input: $input) {
    id
    url
    kind
    name
    width
    height
    duration
    folder_id
    createdAt
  }
}
`

export const GET_MY_USER_MEDIA_FOLDERS = gql`
query myUserMediaFolders {
  myUserMediaFolders {
    id
    name
    media_count
    createdAt
  }
}
`

export const UPDATE_MY_USER_MEDIA = gql`
mutation updateMyUserMedia($id: ID!, $input: MyUserMediaUpdateInput!) {
  updateMyUserMedia(id: $id, input: $input) {
    id
    url
    kind
    name
    width
    height
    duration
    folder_id
    createdAt
  }
}
`

export const DELETE_MY_USER_MEDIA = gql`
mutation deleteMyUserMedia($id: ID!) {
  deleteMyUserMedia(id: $id)
}
`

export const CREATE_MY_USER_MEDIA_FOLDER = gql`
mutation createMyUserMediaFolder($name: String!) {
  createMyUserMediaFolder(name: $name) {
    id
    name
    media_count
    createdAt
  }
}
`

export const UPDATE_MY_USER_MEDIA_FOLDER = gql`
mutation updateMyUserMediaFolder($id: ID!, $name: String!) {
  updateMyUserMediaFolder(id: $id, name: $name) {
    id
    name
    media_count
    createdAt
  }
}
`

export const DELETE_MY_USER_MEDIA_FOLDER = gql`
mutation deleteMyUserMediaFolder($id: ID!) {
  deleteMyUserMediaFolder(id: $id)
}
`

export const STOCK_MEDIA_SEARCH = gql`
query stockMediaSearch($kind: StockMediaKind!, $query: String, $page: Int, $provider: StockMediaProvider) {
  stockMediaSearch(kind: $kind, query: $query, page: $page, provider: $provider) {
    page
    has_more
    items {
      id
      provider
      kind
      thumbnail_url
      preview_url
      file_url
      width
      height
      duration
      author
      author_url
      source_url
      download_location
    }
  }
}
`

export const TRACK_STOCK_MEDIA_USE = gql`
mutation trackStockMediaUse($provider: StockMediaProvider!, $download_location: String!) {
  trackStockMediaUse(provider: $provider, download_location: $download_location)
}
`

export type ClipMcpGrant = {
  id: string
  label?: string | null
  expires_at?: string | null
  revoked_at?: string | null
  last_used_at?: string | null
}

export const MY_CLIP_MCP_GRANTS = gql`
query myClipMcpGrants {
  myClipMcpGrants {
    id
    label
    expires_at
    revoked_at
    last_used_at
  }
}
`

export const REVOKE_MY_CLIP_MCP_GRANT = gql`
mutation revokeMyClipMcpGrant($id: ID!) {
  revokeMyClipMcpGrant(id: $id) {
    id
    label
    expires_at
    revoked_at
    last_used_at
  }
}
`

export const ADMIN_CAMPAIGN_LIVE_IMPORT = gql`
  query AdminCampaignLiveImport($campaignId: ID!) {
    adminCampaignLiveImport(campaignId: $campaignId) {
      campaign_id
      enabled
      channel_id
      channel_name
      channel_thumbnail
      keywords
      format
      language
      prompt
      notify_participants
      enabled_at
      last_checked_at
      next_check_at
      last_error
      items { id video_id title aired_at status email_sent_at email_recipients updated_at }
    }
  }
`;

export const ADMIN_SAVE_CAMPAIGN_LIVE_IMPORT = gql`
  mutation AdminSaveCampaignLiveImport($campaignId: ID!, $input: AdminCampaignLiveImportInput!) {
    adminSaveCampaignLiveImport(campaignId: $campaignId, input: $input) {
      campaign_id
      enabled
      channel_id
      channel_name
      channel_thumbnail
      keywords
      format
      language
      prompt
      notify_participants
      enabled_at
      last_checked_at
      next_check_at
      last_error
      items { id video_id title aired_at status email_sent_at email_recipients updated_at }
    }
  }
`;

export const ADMIN_RUN_CAMPAIGN_LIVE_IMPORT = gql`
  mutation AdminRunCampaignLiveImport($campaignId: ID!) {
    adminRunCampaignLiveImport(campaignId: $campaignId) {
      campaign_id
      enabled
      channel_id
      channel_name
      channel_thumbnail
      keywords
      format
      language
      prompt
      notify_participants
      enabled_at
      last_checked_at
      next_check_at
      last_error
      items { id video_id title aired_at status email_sent_at email_recipients updated_at }
    }
  }
`;
